// extracted by mini-css-extract-plugin
export var textInput = "_jp-0";